import React from 'react'
import Radio from '@components/Radio/Radio'
import Button from '@components/Button'

interface RadioCardProps {
  selected: boolean
  onClick?: React.DOMAttributes<HTMLButtonElement>['onClick']
  children: React.ReactNode
}

interface Props {
  selected?: boolean
  setSelected: (value: boolean) => void
  singleButton?: boolean
  isAlreadySubscribed?: boolean
  isButtonLoading: boolean
}

const RadioCard = ({ selected, onClick, children }: RadioCardProps) => {
  const color = selected ? 'black' : 'border-verylight-gray'

  return (
    <div className={`md:basis-1/2 flex text-center py-6 px-12 rounded-lg border-1 border-${color} mb-3 cursor-pointer relative`} onClick={onClick}>
      <div className="absolute top-3 right-3">
        <Radio selected={selected} />
      </div>
      {children}
    </div>
  )
}

const CaarlForm = ({ selected, setSelected, singleButton, isAlreadySubscribed, isButtonLoading }: Props) => {
  // for account page version
  const singleButtontext = isAlreadySubscribed ? 'Accéder au service' : 'Essayer gratuitement'

  return (
    <div className="">
      <img src="/assets/icons/caarl-logo.svg" className="mx-auto mb-3 h-[26px] w-auto" />
      <h2 className="[&&]:text-base [&&]:text-center [&&]:p-0 mb-4">Caarl, l'assistance juridique</h2>
      <div className="bg-new-verylight-gray border-verylight-gray border-1 rounded-lg flex pl-3 pr-4 py-4 mb-8">
        <div className="h-5 w-5 mr-2 shrink-0 text-sm items-baseline">💡</div>
        <div className="text-sm text-left items-baseline italic">Chez Ma Domiciliation.fr, on accompagne chaque jour des entrepreneurs comme vous. C’est pourquoi on recommande vivement Caarl, l’assistance juridique en ligne la mieux notée par ses utilisateurs !</div>
      </div>
      <ul className="text-left text-sm mb-8 ml-[30px] [&&]:list-[circle]">
        <li>Plus de 500 000 entrepreneurs satisfaits</li>
        <li>Chatbot juridique et plateforme documentaire (modèles de CGV…) : illimité</li>
        <li>4 RDV avec des juristes par an</li>
        <li>3 consultations avec des avocats par an</li>
        <li>7 jours offerts puis 29,90€ HT/mois sans engagement. Option résiliable en 1 clic depuis votre espace client.</li>
        <li>Recouvrement amiable par des huissiers en illimité</li>
      </ul>
      {singleButton ? 
        (
          <div className="flex flex-col md:flex-row gap-3">
            <Button
              isLoading={isButtonLoading}
              onClick={() => setSelected(true)}
              className='max-w-[300px] mx-auto'
            >
              {singleButtontext}
            </Button>
          </div>
        ) : (
        <div className="flex flex-col md:flex-row gap-3">
          <RadioCard
            selected={selected}
            onClick={() => setSelected(true)}
          >
            <div className="text-center">
                <div className="text-sm">Essayer gratuitement</div>
            </div>
          </RadioCard>
          <RadioCard
            selected={!selected}
            onClick={() => setSelected(false)}
          >
            <div className="text-center mx-auto">
                <div className="text-sm">Non, je ne suis pas intéressé</div>
            </div>
          </RadioCard>
        </div>
      )}
    </div>
  )
}

export default CaarlForm